module.exports = __webpack_public_path__ + "img/028-comparison.52df16d2.svg";